import { useTranslation } from "react-i18next"

import styles from "./Title.module.scss"

const Title = () => {
    const { t  } = useTranslation()

    return (
        <div className={styles.homeConfigureTitle}>
            <h1>{t("home configure title")}</h1>
        </div>
    )
}

export default Title